import BaseCommand from "@/models/api/commands/BaseCommand";

export class RedoCommand extends BaseCommand {
  CommandName = "Redo";
  Command = null;
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
